
import { Component } from 'vue-property-decorator';
import LogsList, { LogFields, parseBoolean, parseEnum } from './LogsList.vue';

@Component
export default class PleuralLogs extends LogsList {
  public getTitle(): string {
    return 'Pleural logs';
  }

  public getSpecificFields(): LogFields {
    return {
      ultrasound: {
        label: 'Ultrasound',
        formatter: parseEnum
      },
      aspiration: {
        label: 'Aspiration',
        formatter: parseEnum
      },
      drain: {
        label: 'Drain',
        formatter: parseBoolean
      },
      ipc: {
        label: 'IPC',
        formatter: parseBoolean
      },
      thorascopy: {
        label: 'Thorascopy',
        formatter: parseBoolean
      },
      pleuralBiopsy: {
        label: 'Pleural Biopsy',
        formatter: parseBoolean
      },
      result: {
        label: 'Biology/Citology result'
      }
    };
  }

  protected getCollectionName(): string {
    return 'logs';
  }
}
